var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3468_9948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 8.75024V12.4302C10.9998 12.7802 11.1898 13.1102 11.4898 13.2902L14.6098 15.1402C14.9698 15.3502 15.4298 15.2302 15.6398 14.8802C15.8498 14.5202 15.7398 14.0602 15.3798 13.8502L12.5098 12.1402V8.74024C12.4998 8.34024 12.1598 8.00024 11.7498 8.00024C11.3398 8.00024 10.9998 8.34024 10.9998 8.75024ZM20.9998 9.50024V4.21024C20.9998 3.76024 20.4598 3.54024 20.1498 3.86024L18.3698 5.64024C16.5598 3.83024 13.9798 2.79024 11.1598 3.04024C6.96976 3.42024 3.51976 6.79024 3.05976 10.9802C2.45976 16.4002 6.68976 21.0002 11.9998 21.0002C16.5898 21.0002 20.3798 17.5602 20.9298 13.1202C20.9998 12.5202 20.5298 12.0002 19.9298 12.0002C19.4298 12.0002 19.0098 12.3702 18.9498 12.8602C18.5198 16.3502 15.5098 19.0502 11.8998 19.0002C8.18976 18.9502 5.05976 15.8202 4.99976 12.1002C4.93976 8.20024 8.10976 5.00024 11.9998 5.00024C13.9298 5.00024 15.6798 5.79024 16.9498 7.05024L14.8598 9.14024C14.5398 9.46024 14.7598 10.0002 15.2098 10.0002H20.4998C20.7798 10.0002 20.9998 9.78024 20.9998 9.50024Z",
    fill: "#A0A0A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3468_9948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/updateIcon.51698fce9c4f79225c67425f1fb2cbe5.svg";
export { ForwardRef as ReactComponent };